
import React from "react";
import { useStateManager } from "@bcm-dev/bcms-vite";
import { SVGAsset } from "res";
import "./styles.css";
import { UIButton } from "components/ui";

export default function ChatEndSessionPopup(props) {
  const { ui, onUIClick, onEndSession } = useStateManager();
  const { showEndSessionPopup } = ui ?? {};
  const openClass = showEndSessionPopup ? "open" : "";

  const endSessionBtn = () => {
      onEndSession();
  }

  return (
    <div className={`chat-popup end-session-popup ${openClass}`}>
      <div className="end-session-popup-container flex-container flex-vertical">
        <div className="flex-container flex-horizontal align-center end-session-header">
          <div className="flex-width"></div>
          <div className="set-width clickable" onClick={ onUIClick("showEndSessionPopup", false) } >
              <SVGAsset id="CloseX" className="icon x-icon" />      
          </div>
        </div>
        <div className="flex-container flex-horizontal align-center button-container">
          <UIButton text="End Session" className="end-session-button chat-button flex-width clickable" onClick={ onEndSession } />
        </div>
      </div>
    </div>
  )
}
